import { BooleanInput } from '@angular/cdk/coercion';
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Input,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { SecurityContextSupplier } from 'app/core/authorization';
import { UserProfile, UserProfileService } from 'app/core/user/user-profile.service';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { combineLatest, startWith, Subject, takeUntil } from 'rxjs';
import packageInfo from '../../../../../package.json';
import { AppService } from 'app/app.service';

@Component({
	selector: 'user',
	templateUrl: './user.component.html',
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	exportAs: 'user',
})
export class UserComponent implements OnInit, OnDestroy {
	/* eslint-disable @typescript-eslint/naming-convention */
	static ngAcceptInputType_showAvatar: BooleanInput;
	/* eslint-enable @typescript-eslint/naming-convention */

	@Input() showAvatar: boolean = true;
	user: User;
	version = packageInfo.version;

	private _unsubscribeAll: Subject<any> = new Subject<any>();

	/**
	 * Constructor
	 */
	constructor(
		private _changeDetectorRef: ChangeDetectorRef,
		private _router: Router,
		private _userService: UserService,
		// private _keycloakService: KeycloakService
		private _securityContextSupplier: SecurityContextSupplier,
		public readonly appService: AppService,
		private _userProfileService: UserProfileService
	) {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		// Subscribe to user changes. O avatar vem do perfil (pmo.UserProfile): o Keycloak
		// nao tem foto, entao user.avatar ficava sempre vazio e o icone nunca saia.
		combineLatest([this._userService.user$, this._userProfileService.profile$.pipe(startWith(null))])
		     .pipe(takeUntil(this._unsubscribeAll))
		     .subscribe(([user, profile]: [User, UserProfile | null]) => {
		         this.user = { ...user, avatar: profile?.avatar ?? user?.avatar };

		         // Mark for check
		         this._changeDetectorRef.markForCheck();
		     });
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Update the user status
	 *
	 * @param status
	 */
	updateUserStatus(status: string): void {
		// Return if user is not available
		if (!this.user) {
			return;
		}

		// Update the user
		this._userService
			.update({
				...this.user,
				status,
			})
			.subscribe();
	}

	/**
	 * Sign out
	 */
	async signOut(): Promise<void> {
		// this._router.navigate(['/sign-out']);
		// this._keycloakService.logout(environment.auth.logoutUri);
		this._securityContextSupplier.logout();
	}

	/**
	 * Sign out
	 */
	changelog(): void {
		this._router.navigate(['/apps/atualizacoes']);
	}
}
